import React from "react";
import { default as ReactSelect } from "react-select";
import colors from "./../../styles/_colors.scss";
import "./Select.scss";

const customStyles = {
	control: (base, state) => ({
		...base,
		boxShadow: "none",
	}),
};

function Select(props) {
	return (
		<div className={props.customStylingClass}>
			{props.label ? (
				<label htmlFor={props.id}>
					{props.label}
					{props.required ? (
						<span className="required ml5">*</span>
					) : null}
				</label>
			) : null}
			<ReactSelect
				styles={customStyles}
				theme={(theme) => ({
					...theme,
					colors: {
						...theme.colors,
						primary25: colors.primary,
						primary: colors.primarycolor,
					},
				})}
				{...props}
			/>
		</div>
	);
}

export default Select;
